<template>
  <div>
    <sdCards title="Basic Line Chart">
      <line-chart />
    </sdCards>
  </div>
</template>

<script>
import { Main } from '../../styled';
import LineChart from '@/components/apexcharts/line-chart/BasicLine';
export default {
  name: 'OrderStatistics',
  components: {
    Main,
    LineChart,
  },
};
</script>
